import { useMutation } from 'react-query'
import { cancelReason, type CancelReasonPayload } from '../api/subscriptionApi'

/**
 * Сохранить причину отмены подписки (Tribute).
 * Только логирует причину оттока — auto_renew не трогает, профиль не инвалидирует:
 * реальная отмена происходит в Tribute Mini App, куда редиректим после успеха.
 */
export const useCancelReasonMutation = () => {
  return useMutation<void, Error, CancelReasonPayload>(cancelReason)
}
